var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn-download layout-align-start-center layout-row",attrs:{"target":"_blank","href":_vm.data.url}},[_c('span',{staticClass:"grey2 italic"},[_vm._v(_vm._s(_vm.data.prompt))]),_c('i',{staticClass:"ai-right"}),_c('span',{staticClass:"h4"},[_vm._v(_vm._s(_vm.data.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }